// Doux Présent : ajout au panier avec mise à jour du drawer Horizon + upsell bracelet
import { CartLinesUpdateEvent } from '@shopify/events';

const racine = () => (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');

/**
 * Ajoute des lignes au panier, met à jour le drawer et le compteur, puis ouvre le drawer.
 * @param {Array<{id:number, quantity:number, properties?:Object}>} items
 * @param {{ouvrir?: boolean}} [options]
 */
async function ajouter(items, { ouvrir = true } = {}) {
  const sections = [...document.querySelectorAll('cart-items-component')]
    .map((c) => c.dataset.sectionId)
    .filter(Boolean);
  const differe = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: items.map((i) => ({ merchandiseId: `gid://shopify/ProductVariant/${i.id}`, quantity: i.quantity })),
      promise: differe.promise,
    })
  );
  try {
    const reponse = await fetch(racine() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: sections.join(','), sections_url: window.location.pathname }),
    });
    const data = await reponse.json();
    if (!reponse.ok) throw new Error(data.description || data.message || 'Ajout impossible');
    const panier = await fetch(racine() + 'cart.js').then((r) => r.json());
    differe.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(panier),
      detail: { sections: data.sections, items: data.items, itemCount: panier.item_count, source: 'dp-panier', didError: false },
    });
    if (ouvrir) ouvrirPanier();
    return panier;
  } catch (erreur) {
    differe.reject(erreur);
    throw erreur;
  }
}

function ouvrirPanier() {
  const drawer = document.querySelector('theme-drawer#cart-drawer');
  if (drawer && typeof drawer.open === 'function') drawer.open();
  else if (window.Shopify?.actions?.openCart) window.Shopify.actions.openCart();
  else window.location.href = racine() + 'cart';
}

window.dpPanier = { ajouter, ouvrirPanier };

// Upsell « Le même en bracelet ? »
document.addEventListener('click', async (e) => {
  const lien = e.target.closest('[data-dp-upsell-edit]');
  if (lien) {
    lien.closest('.dp-upsell')?.classList.toggle('edit');
    return;
  }
  const bouton = e.target.closest('[data-dp-upsell-add]');
  if (!bouton) return;
  const carte = bouton.closest('.dp-upsell');
  const p1 = carte.querySelector('[name="dp-p1"]').value.trim();
  const p2 = carte.querySelector('[name="dp-p2"]').value.trim();
  if (!p1) {
    carte.classList.add('edit');
    carte.querySelector('[name="dp-p1"]').focus();
    return;
  }
  const texte = bouton.textContent;
  bouton.disabled = true;
  bouton.textContent = 'Ajout…';
  try {
    const proprietes = { 'Prénom 1': p1 };
    if (p2) proprietes['Prénom 2'] = p2;
    await ajouter([{ id: Number(carte.dataset.variant), quantity: 1, properties: proprietes }], { ouvrir: false });
  } catch (erreur) {
    bouton.disabled = false;
    bouton.textContent = texte;
    alert("Oups, le bracelet n'a pas pu être ajouté. Réessayez.");
  }
});

// Met à jour l'aperçu des prénoms quand on les modifie
document.addEventListener('input', (e) => {
  const champ = e.target.closest('.dp-upsell__champs input');
  if (!champ) return;
  const carte = champ.closest('.dp-upsell');
  const p1 = carte.querySelector('[name="dp-p1"]').value.trim();
  const p2 = carte.querySelector('[name="dp-p2"]').value.trim();
  const noms = carte.querySelector('[data-dp-noms]');
  if (noms) noms.textContent = p2 ? `${p1} & ${p2}` : p1;
});
